import { Routes, Route } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext.jsx';
import AppShell from './components/layout/AppShell.jsx';
import Organizations from './pages/Organizations.jsx';
import OrgDetail from './pages/OrgDetail.jsx';
import PlatformUsers from './pages/PlatformUsers.jsx';
import PlatformHealth from './pages/PlatformHealth.jsx';
import SupportTickets from './pages/SupportTickets.jsx';

function AuthGate({ children }) {
  const { loading, isAuthenticated, error } = useAuth();

  if (loading) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50">
        <div className="text-center">
          <div className="mx-auto h-8 w-8 animate-spin rounded-full border-4 border-blue-600 border-t-transparent" />
          <p className="mt-4 text-sm text-gray-500">Loading...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return (
      <div className="flex h-screen items-center justify-center bg-gray-50">
        <div className="max-w-md rounded-lg bg-white p-8 text-center shadow-lg">
          <h1 className="text-xl font-bold text-gray-900">Access Denied</h1>
          <p className="mt-2 text-sm text-gray-600">
            {error || 'Access restricted to Colorado Communications administrators.'}
          </p>
        </div>
      </div>
    );
  }

  return children;
}

export default function App() {
  return (
    <AuthProvider>
      <AuthGate>
        <Routes>
          <Route element={<AppShell />}>
            <Route path="/"                  element={<Organizations />} />
            <Route path="/orgs/:orgId"       element={<OrgDetail />} />
            <Route path="/platform-users"    element={<PlatformUsers />} />
            <Route path="/platform-health"   element={<PlatformHealth />} />
            <Route path="/support"           element={<SupportTickets />} />
          </Route>
        </Routes>
      </AuthGate>
    </AuthProvider>
  );
}
